import { render } from "./ward.vue?vue&type=template&id=e0d0ff14"
import script from "./ward.vue?vue&type=script&lang=js"
export * from "./ward.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__